module.exports = __webpack_public_path__ + "img/ethereum-eth-logo.86b356aa.png";